<template>
  <div class="custom-input">
    <label :for="id"> {{ label }}: </label>    
    <input 
      :id="id"
      :type="type"
      :value="value"
      @input="onInput"
      :class="{valid: required && isValid, invalid: required && !isValid}"
      autocomplete="off"
      @change="onChange"
      @keyup.enter="type === 'search' ? $emit('search-action') : ''"
      :readonly="readonly"
      :max="max"
      :min="min"
    >
  </div>
</template>

<script>
export default {
  props: [
    'value', 
    'type', 
    'label', 
    'id', 
    'required', 
    'confirm', 
    'readonly', 
    'max', 
    'min',
  ],
  computed: {
    isValid() {
      if (!this.confirm) {
        return this.value ? true : false  
      } else {
        return this.value === this.confirm ? true : false
      }
    }
  },
  methods: {
    onInput(event) {
      if (this.type === 'number') {
        // event.target.value = event.target.value.replace(/[^\d]/g, '')
        if (this.max && event.target.value > this.max) {
          event.target.value = this.max
        }
        if (this.min && event.target.value < this.min) {
          event.target.value = this.min
        }
      }
      this.$emit('input', event.target.value)
    },
    onChange(event) {
      if (this.type === 'search') {
        this.$emit('search-action')
      }
      this.$emit('change', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-input {
  display: flex;  
  flex-direction: column;

  & label {
    font-size: 15px;
  }
}
input {
  padding: 10px;
  border: 1px solid rgba(60,60,60,.26);
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  text-align: left;  
}

.valid {
  border-left-color: rgb(175, 233, 169);
  border-left-width: 4px;
}

.invalid {
  border-left-color: rgb(255, 151, 144);
  border-left-width: 4px;
}
</style>